import { getItemsIds } from '../../../utils/common'
import { EMAIL_CREATION_FORM_API_KEY_COPY_TO_ARCHIVE } from '../EmailCreationForm'

import {
  EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_BUILDING,
  EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_FLAT,
} from './EmailCopyToEntityFilterModal'
import {
  EMAIL_COPY_TO_ENTITY_MODAL_API_ENTITY_NAME_BUILDING,
  EMAIL_COPY_TO_ENTITY_MODAL_API_ENTITY_NAME_FLAT,
  EMAIL_COPY_TO_ENTITY_MODAL_API_ENTITY_NAME_USER,
  EMAIL_COPY_TO_ENTITY_MODAL_API_FIELD,
  EMAIL_COPY_TO_ENTITY_MODAL_FIELD_NAME_USER,
} from './EmailCopyToEntityModal.constants'

export function getEmailCopyToModalFilterPayload(values) {
  return {
    [EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_BUILDING]: getItemsIds(
      values[EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_BUILDING],
      'value'
    ),
    [EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_FLAT]: getItemsIds(
      values[EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_FLAT],
      'value'
    ),
  }
}

export function getEmailCopyToModalPayload(values) {
  return values[EMAIL_COPY_TO_ENTITY_MODAL_FIELD_NAME_USER].reduce(
    (acc, current) => {
      return [...acc, toEmailCopyToEntityApiDataUser({ id: current.value })]
    },
    []
  )
}

export function toEmailCopyToEntityApiData({ id, name }) {
  return {
    [EMAIL_COPY_TO_ENTITY_MODAL_API_FIELD.entityId]: id,
    [EMAIL_COPY_TO_ENTITY_MODAL_API_FIELD.entityName]: name,
  }
}

export function toEmailCopyToEntityApiDataUser({ id }) {
  return toEmailCopyToEntityApiData({
    id,
    name: EMAIL_COPY_TO_ENTITY_MODAL_API_ENTITY_NAME_USER,
  })
}

export function toEmailCopyToEntityApiDataFlat({ id }) {
  return toEmailCopyToEntityApiData({
    id,
    name: EMAIL_COPY_TO_ENTITY_MODAL_API_ENTITY_NAME_FLAT,
  })
}

export function toEmailCopyToEntityApiDataBuilding({ id }) {
  return toEmailCopyToEntityApiData({
    id,
    name: EMAIL_COPY_TO_ENTITY_MODAL_API_ENTITY_NAME_BUILDING,
  })
}

export function withEmailCopyToArchiveUsers(payload, userIds) {
  return {
    ...payload,
    [EMAIL_CREATION_FORM_API_KEY_COPY_TO_ARCHIVE]: userIds.map(id =>
      toEmailCopyToEntityApiDataUser({ id })
    ),
  }
}
